// extracted by mini-css-extract-plugin
export default {"mediaOverlayRoot":"gfVQQU","mediaOverlayRibbonsAndSlotContainer":"QVeW58"};